import * as yup from 'yup';

export const passwordValidator = () =>
	yup
		.string()
		.test('no-spaces', 'password.no_spaces', (value) => {
			if (!value) {
				return true;
			}
			return !/\s/.test(value);
		})
		.matches(
			/^(?!.*\s)(?=.*[a-zäöüß])(?=.*[A-ZÄÖÜẞ])(?=.*[a-zA-ZäöüßÄÖÜẞ])(?=.*[!@#$%^&*?(){}[\]/|=~\-+.,_><:]).{8,30}$/,
			'password.incorrect'
		);
